import { fetchPublicTourLanguages } from 'actions/translationsActions';
import Select from 'components/Inputs/Select/Select';
import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './LanguageSelect.scss';

const LanguageSelect = props => {
  const { tourId, handleChange, selectedLang } = props;
  const { publishedTourLanguages = [], status } = useSelector(
    state => state.translations
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (publishedTourLanguages.length < 1 && status === 'ok') {
      dispatch(fetchPublicTourLanguages(tourId));
    }
  }, [publishedTourLanguages, dispatch, status, tourId]);

  const getEnabledOptions = () =>
    publishedTourLanguages.map(lang => ({
      tourId,
      name: lang.displayName,
      value: lang.code,
    }));

  if (publishedTourLanguages.length === 0) {
    return null;
  }

  return (
    <>
      <h3>Select Language</h3>
      <p>If a language is not set the tour will default to english.</p>
      <Select
        data-testid="lang-select"
        className="lang-select"
        handleChange={handleChange}
        selected={selectedLang}
        options={getEnabledOptions()}
      />
    </>
  );
};

export default memo(LanguageSelect);
